export const appDownloadButtonTheme = {
  appDownloadButtonGutter: '--medkit-app-download-gutter',
  appDownloadButtonHeight: '--medkit-app-download-height',
}
